import { Injectable } from '@angular/core';
import { tr } from '@kpd/framework-ngx';
import { AuthenticationProviders } from '../enums/authentication-providers';

export interface IUserType {
  name: string;
  authProviders: number[];
  passwordNeeded?: boolean;
  id: number;
}

@Injectable()
export class UserTypeService {
  getUserTypes(): IUserType[] {
    return [
      {
        name: tr('Active directory user'),
        authProviders: [2, 3],
        passwordNeeded: false,
        id: AuthenticationProviders.azureAd,
      },
      {
        name: tr('Local user'),
        authProviders: [1, 3],
        passwordNeeded: true,
        id: AuthenticationProviders.local,
      },
    ];
  }
}
